//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from "vant";
import { getInfo } from "@/api/my";
import { wxLogin, wxLoginH5, registerSms, codeLogin } from "@/api/login";
import aes from '@/assets/js/secret.js'
import { phoneVer } from '../../assets/js/verificat'
export default {
  name: "login",
  data: function() {
    return {
      isWeChat: false,
      isCheck: false,
      checked: false,
      title: '登录',
      isLogin: false,
      disabled: false,
      name: '',
      phoneNum: '',
      password: '',
      code: '',
      isAgree: false,
      second: 60,
      showText: true,
      top: 0,
      type: 0,
      code: "",
      alipayAppId: "2021003183638029",
      alipayPid: "2088931900075750",
      wxAppId: "wx312b0d62d88de1ab", // 公众号
      redirectUri: "",
    };
  },
  created() {
    this.redirectUri = process.env.BASE_URL + '/login'
    console.log(navigator.userAgent);
    if (this.$global.isApp) {
      this.top = api.safeArea.top;
    } else {
      let browser = navigator.userAgent.toLowerCase();
      this.isWeChat = browser.includes("micromessenger");
      console.log("是否微信浏览器：", this.isWeChat);
      this.code = this.getQueryString("code");
      if (this.code) {
        this.doWxLoginH5();
      }
      let info = localStorage.getItem("userInfo");
      if (info !== null) {
        this.$router.push({
          path: "/home",
        });
      }
    }
    this.type = parseInt(this.$route.query.type);
    console.log(this.type);
  },
  activated() {},
  methods: {
    // isWx () {
    // 	var ua = navigator.userAgent.toLowerCase()
    // 	if (ua.match(/MicroMessenger/i) === 'micromessenger') {
    // 		return true
    // 	} else {
    // 		return false
    // 	}
    // },
    onclickLeft() {
      this.$router.goBack();
    },
    goUserAgreement () {
      this.$router.push({
        path: '/userAgreement'
      })
    },
    goPrivacy () {
      this.$router.push({
        path: '/privacy'
      })
    },
    // 获取登录验证码
    getCode: (function () {
      if (this.phoneNum === '') {
        this.$toast('请输入手机号')
        return
      }
      if (!phoneVer(this.phoneNum)) {
        this.$toast('手机号格式不正确')
        return
      }
      let _this = this
      registerSms({
        aesPhone: aes.encrypt(JSON.stringify({
          time: new Date().getTime(),
          phone: this.phoneNum
        }))
      }).then(res => {
        console.log(res)
        _this.$toast(res.message)
        _this.showText = false
        var interval = setInterval(() => {
          let times = --_this.second
          _this.second = times < 10 ? '0' + times : times // 小于10秒补 0
        }, 1000)
        setTimeout(() => {
          clearInterval(interval)
          _this.second = 60
          _this.showText = true
        }, 60000)
      })
        .catch(err => {
          console.log(err)
        })
    }),
    goLogin () {
      this.$router.replace({
        path: '/login'
      })
    },
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    // 登录
    login () {
      if (!this.phoneNum) {
        this.$toast('请输入手机号')
        return
      }
      if (!this.code) {
        this.$toast('请输入验证码')
        return
      }
      if (!this.checked) {
        this.$toast('请先同意用户协议和隐私政策')
        return
      }
      this.isLogin = true
      this.smsLogin()
    },
    // 验证码登录
    smsLogin () {
      this.$toast.loading({
        duration: 1000, // 持续展示 toast
        forbidClick: true,
        loadingType: 'spinner'
      })
      let formData = new FormData()
      let inviteCode = localStorage.getItem('inviteCode') || ''
      formData.append('phone', this.phoneNum)
      formData.append('authCode', this.code)
      if (inviteCode) {
        formData.append('inviteCode', inviteCode)
      }
      localStorage.setItem('uuid', this.getUuid())
      codeLogin(formData)
        .then(res => {
          if (res.code === 200) {
            localStorage.setItem('token', res.data.token)
            if (inviteCode) {
              localStorage.removeItem('inviteCode')
            }
            this.getUser()
            this.$router.push({
              name: 'home'
            })
          }
        }).catch(v => {
          this.$toast(v.message)
        })
    },
    getUser () {
      getInfo().then(res => {
        localStorage.setItem('userInfo', JSON.stringify(res.data))
      })
    },
    agreement () {
      console.log('用户协议')
      this.$router.push({
        path: '/userAgreement'
      })
    },
    privacy () {
      console.log('隐私政策')
      this.$router.push({
        path: '/privacy'
      })
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    toAgreement() {
      this.$router.push({
        path: "/userAgreement",
      });
    },
    toPrivacy() {
      this.$router.push({
        path: "/privacy",
      });
    },
    goLoginModel () {
      this.$router.replace({
        path: "/login-model",
      });
    },
    submit() {
      if (!this.checked) {
        this.isCheck = true
        setTimeout(() => {
          this.isCheck = false
        }, 1000)
        return;
      }
      if (this.$global.isApp) {
        this.loginWX();
      } else {
        this.loginWXH5();
      }
    },
    loginWXH5() {
      location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.wxAppId +
        "&redirect_uri=" +
        this.redirectUri +
        "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
    },
    loginWX() {
      let _this = this;
      var wxPlus = api.require("wxPlus");
      wxPlus.isInstalled(function(ret, err) {
        if (ret.installed) {
          wxPlus.auth(function(ret, err) {
            console.log("微信auth:", JSON.stringify(ret));
            console.log(JSON.stringify(err));
            if (ret.status) {
              console.log("wxLogin");
              wxLogin({
                code: ret.code,
              })
                .then((res) => {
                  console.log("wxLogin:", JSON.stringify(res));
                  Toast("登录成功");
                  // setTimeout(() => {
                  _this.getUser();
                  // }, 1000);
                })
                .catch((err) => {
                  console.log("wxlogin err", err);
                });
            }
          });
        } else {
          // alert('当前设备未安装微信客户端');
          api.toast({
            msg: "当前设备未安装微信客户端",
            duration: 2000,
            location: "middle",
          });
        }
      });
    },
    doWxLoginH5() {
      let _this = this;
      let params = {
        code: this.code
      };
      let inviteCode = localStorage.getItem("inviteCode") || "";
      if (inviteCode) {
        params.inviteCode = inviteCode;
      }
      wxLoginH5(params)
        .then((res) => {
          console.log("wxLoginH5:", res);
          localStorage.setItem("token", res.data.token);
          Toast("登录成功");
          // setTimeout(() => {
          if (inviteCode) {
            localStorage.removeItem("inviteCode");
          }
          _this.getUserH5();
          // }, 1000);
        })
        .catch((err) => {
          console.log("wxlogin err", err);
        });
    },
    getUserH5() {
      getInfo().then((res) => {
        if (res.data) {
          localStorage.setItem("userInfo", JSON.stringify(res.data));
        }
        this.$router.replace({
          name: "home",
        });
      });
    },
    getUser() {
      getInfo().then((res) => {
        if (res.data && res.data.openId) {
          localStorage.setItem("openId", res.data.openId);
          this.onclickLeft();
        }
      });
    },
    toAgreement() {
      this.$router.push({
        path: "/userAgreement",
      });
    },
    toPrivacy() {
      this.$router.push({
        path: "/privacy",
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/Login/login.vue